<section class="page-container">
    <div class="container-fluid ptCustom">
        <div class="my-2">
            <a [routerLink]="['/admin-portal/chamber/pending-discounts']" class="text-white"><i class="fa-regular fa-angle-left"></i> back to all pending discounts</a>
        </div>
        <div class="row">
            <div class="col-lg-8 col-md-8 my-2">
                <div class="card shadow-sm rounded-lg">
                    <div class="card-body p-4">
                        <div class="detailsContainer">
                            <div class="detailsHeader">
                                <h4>Discount Information</h4>
                                <a href="javascript:void(0);" (click)="openEditModal()"><i class="fa-regular fa-pencil"></i></a>
                            </div>
                            <div class="detailsSection">
                                <div class="row">
                                    <div class="col-auto">
                                        <div class="detailsBlock">
                                            <div class="dataLabel">
                                                <span>Member</span>
                                            </div>
                                            <div class="dataOutput">
                                                <span>{{discount.submitterName}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-auto">
                                        <div class="detailsBlock">
                                            <div class="dataLabel">
                                                <span>Company</span>
                                            </div>
                                            <div class="dataOutput">
                                                <span>{{discount.companyName}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="detailsBlock">
                                            <div class="dataLabel">
                                                <span>Value</span>
                                            </div>
                                            <div class="dataOutput">
                                                <span>{{discount.value}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="detailsBlock">
                                            <div class="dataLabel">
                                                <span>Date Range</span>
                                            </div>
                                            <div class="dataOutput">
                                                <span>{{dateRangeString}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="detailsBlock">
                                            <div class="dataLabel">
                                                <span>Redemption Limit</span>
                                            </div>
                                            <div class="dataOutput">
                                                <span>{{discount.redemptionLimit}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 my-2">
                <div class="card shadow-sm rounded-lg">
                    <div class="card-body p-4">
                        <div class="detailsContainer">
                            <div class="detailsHeader justify-content-center">
                                <h4>Review Discount</h4>
                            </div>
                            <div class="detailsSection">
                                <div class="detailsBlock">
                                    <div class="dataLabel">
                                        <span>Request Submitted</span>
                                    </div>
                                    <div class="dataOutput">
                                        <span>{{getDateString(this.discount.submissionDate)}}</span>
                                    </div>
                                </div>
                                <div *ngIf="!discount.isClosed">
                                    <div class="mb-3">
                                        <input [(ngModel)]="discount.approverNotes" type="text" class="form-control" id="exampleNotes" placeholder="Notes">
                                    </div>
                                    <div class="mb-4">
                                        <a href="javascript:void(0);" (click)="PublishArticle(1)" type="button" class="btn btn-add text-strong hvr-grow w-100"><i class="fa-solid fa-check"></i> approve discount</a>
                                    </div>
                                    <div class="text-center">
                                        <a href="javascript:void(0);" (click)="PublishArticle(2)" class="text-white"><small>reject discount</small></a>
                                    </div>
                                </div>
                                <div *ngIf="discount.isClosed">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Status</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span class="d-block">{{discount.status}}</span>
                                        </div>
                                    </div>
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Notes</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span class="d-block">{{discount.approverNotes}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>